import adApi from '../api/adApi';
import { LOAD_CONFIGPROPS_SUCCESS } from './actionTypes';

export function loadConfigPropsSuccess(configPropValues) {
    return { type: LOAD_CONFIGPROPS_SUCCESS, configPropValues };
}